import { API } from '~apis/axios/instance';
import { MemberType } from '~apis/companyuser/getCompanyUserDetail';
import { ResponseBaseWithData } from '~types/response';

export interface CompanyMembersResponse extends ResponseBaseWithData {
  data: MemberType[];
}

interface CompanyIdentifier {
  companyId: string;
}

/**
 * 총 구성원 조회
 * @link https://apollo11.dev.clobe.ai/swagger-ui/index.html#/company-user-controller/getCompanyUserSimpleList
 *
 */
export default function getAllMembers({ companyId }: CompanyIdentifier) {
  return API.get<CompanyMembersResponse>(`/api/v2/companies/${companyId}/users`);
}
